module.exports = __webpack_public_path__ + "2f8813efe0d496c09aa071556f3917e3.png";